import { useEffect, useState } from 'react';

import Amplitude from 'services/Amplitude';
import LocalStorage from 'services/LocalStorage';
import { LocalStorageKey } from 'constants/local-storage';

type UseTabTitleChange = {
  changedPageTitle: string | null;
};

export const useTabTitleChange = (alternateTitles: string[]): UseTabTitleChange => {
  const [changedPageTitle, setChangedPageTitle] = useState<string | null>(null);
  const [isTabVisible, setIsTabVisible] = useState<boolean>(true);

  useEffect(() => {
    const handleVisibilityChange = () => setIsTabVisible(!document.hidden);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    let intervalId: NodeJS.Timeout;
    let currentIndex: number = 0;
    const maxIndex: number = alternateTitles.length - 1;

    if (!isTabVisible) {
      intervalId = setInterval(() => {
        setChangedPageTitle(alternateTitles[currentIndex]);
        currentIndex = currentIndex === maxIndex ? 0 : currentIndex + 1;
      }, 2000);

      Amplitude.logEvent(null, 'SIGNUP_TAB_CHANGED');
      LocalStorage.set(LocalStorageKey.SignupTabChanged, true);
    } else {
      setChangedPageTitle(null);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isTabVisible]);

  return { changedPageTitle };
};
